const ACTION_TYPES = {
    RESET_MODAL_STATE: 'RESET_MODAL_STATE',
    SET_MODAL_OPEN: 'SET_MODAL_OPEN',
    SET_OPEN_MODAL_TYPE: 'SET_OPEN_MODAL_TYPE',
    SET_SHOW_ERROR_SUCCESS_MODAL: 'SET_SHOW_ERROR_SUCCESS_MODAL',
};

function resetModalState() {
    return { type: ACTION_TYPES.RESET_MODAL_STATE };
}

function setModalOpen({ modalOpen }) {
    return { type: ACTION_TYPES.SET_MODAL_OPEN, modalOpen };
}

function setOpenModalType({ openModalType }) {
    return { type: ACTION_TYPES.SET_OPEN_MODAL_TYPE, openModalType };
}

function setShowErrorSuccessModal({ showErrorSuccessModal }) {
    return { type: ACTION_TYPES.SET_SHOW_ERROR_SUCCESS_MODAL, showErrorSuccessModal };
}

export default {
    ...ACTION_TYPES,
    resetModalState,
    setModalOpen,
    setOpenModalType,
    setShowErrorSuccessModal,
};
